import { create } from 'zustand';
import type { AlertColor } from '@mui/material';

export interface AppNotification {
  id: number;
  severity: AlertColor;
  /** Either a ready-made string, or a translation key with values. */
  message?: string;
  messageKey?: string;
  values?: Record<string, string | number>;
}

interface NotificationState {
  items: AppNotification[];
  push: (notification: Omit<AppNotification, 'id'>) => void;
  dismiss: (id: number) => void;
}

let nextId = 1;

export const useNotificationStore = create<NotificationState>((set) => ({
  items: [],
  push: (notification) =>
    set((state) => ({
      // only the newest few are worth showing; older toasts are dropped
      items: [...state.items, { ...notification, id: nextId++ }].slice(-4),
    })),
  dismiss: (id) => set((state) => ({ items: state.items.filter((item) => item.id !== id) })),
}));
